
import React, {Fragment} from 'react'
import {Text, View, StyleSheet} from '@react-pdf/renderer';
const NoData = ({title}) => {
    const styles = StyleSheet.create({
        container: {
            flexDirection: 'row',
            alignItems : 'center',
            justifyContent : 'center',
            fontStyle: 'bold',
            paddingBottom : '5px',
            paddingTop : '10px',
            paddingLeft : '15px',
            border : "1px solid #E4E4E4",
            borderRadius : '5px',
            width : '100%',
            marginTop: '5px',
            marginBottom: '10px',
        },
        text: {
            fontSize: '12px',
            color: '#999999',
        },
    })
  return (
    <Fragment>
        <View style={styles.container}>
            <Text style={styles.text}>No {title}</Text>
        </View>
    </Fragment>
  )
}

export default NoData;